// extracted by mini-css-extract-plugin
export var brand = "_3o-9";
export var compact = "_3o-6";
export var extraSmall = "_3o-7";
export var icon = "_3o-0";
export var large = "_3o-4";
export var light = "_3o-1";
export var medium = "_3o-5";
export var outline = "_3o-b";
export var primaryDark = "_3o-a";
export var primaryLight = "_3o-8";
export var primaryModern = "_3o-c";
export var success = "_3o-2";
export var successSolid = "_3o-3";